import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { iif } from 'rxjs';
import { CentroService } from 'src/app/services/centro.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { LicenciaService } from 'src/app/services/licencia.service';
import { LoginService } from 'src/app/services/login.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { threadId } from 'worker_threads';
import { TablaCentrosContratistaComponent } from '../../tabla-centros-contratista/tabla-centros-contratista.component';

@Component({
  selector: 'app-add-cliente',
  templateUrl: './add-cliente.component.html',
  styleUrls: ['./add-cliente.component.scss']
})
export class AddClienteComponent implements OnInit {

  userLog: any
  clientes: any = []
  instalaciones: any = []
  centroClientes: any = []
  clienteSeleccionado: any
  instalacionSeleccionado:any = []
  instalacionesCentro:any =[]
  centrosYaCliente: any =[]
  centroId: any
  centro:any
  licenciasPagadas:any
  fechaConfirmacion:any
  fechaCaducidad:any
  fechaRenovacion: any
  idClienteCustom:any
  idCentro:any
  licencias:any =[]
  lastLicencia:any
  contadorLicencia:any
  clientesAsignados:any =[]

  constructor(private loginService: LoginService, 
    private contratistaService: ContratistaService, 
    private clienteService: ClienteService, 
    private apollo: Apollo, 
    private centroService: CentroService,
    private licenciaService: LicenciaService, 
    public dialogRef: MatDialogRef<TablaCentrosContratistaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.userLog = loginService.getUserData()
    this.fechaConfirmacion = moment()
    this.fechaCaducidad = moment().add('days', 365)
    this.fechaRenovacion = moment().add('days', 335)
    

  }

  ngOnInit(): void {
    this.getContratistaById()
    this.getLicenciasByContratista()
  
    this.getCentroById()
      
    
      setTimeout(() => {
       
       
      }, 1000);
      
  

  }

 getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      
        this.licenciasPagadas = data.contratista.licenciasPagadas
       
        
        
      })
  }

  getClientesByContrastita() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let clientes = data.contratista.clientes
        let clientesAsignados =[]

        for (let i = 0; i < clientes.length; i++) {
          let equal = false;
          for (let z = 0; z < this.centroClientes.length && !equal; z++) {
            if (clientes[i].id == this.centroClientes[z].id) equal=true
            
                       
          }
          if (!equal) clientesAsignados.push(clientes[i])
        }
       
       
       clientesAsignados.forEach((cliente:any) => {
       
            for (let i = 0; i < cliente.licencias.length; i++) {
          if (cliente.licencias[i].licenciaActiva == false) {
           
            this.clientes.push(cliente)
            break;
          }
          
        }
          
      
      });
        console.log(this.clientes);
        
      }
      )
  }

  getLicenciasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.licenciaService.getLicenciasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
        const licencias = data.contratista.licencias.filter((licencia:any)=>!licencia.IDLicencia)
        this.lastLicencia = licencias[licencias.length-1]
          }
      )
  }

  selectAllInstalaciones(e:any){
   
    if (e) {
      const allInstalaciones = this.instalaciones;
      allInstalaciones.forEach((instalacion:any) => {
        this.instalacionSeleccionado.push(instalacion.id)
      });
    }else{
      this.instalacionSeleccionado = [];
    }
  }

  selectInstalacion(e:any){

    const instalacion= e.value;
    if (e.selected) {
      if (instalacion !=  null) {
        this.instalacionSeleccionado.push(instalacion)
      }
      
    }else{
      this.instalacionSeleccionado = this.instalacionSeleccionado.filter((i:any)=> i !== instalacion )
    }
  }

  selectCliente(e: any) {
    this.getClienteById()
  }

  getInstalacionesByCliente(id: any) {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      variables: {
        "id": id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.instalaciones = data.cliente.instalaciones
      }
      )
  }

  getCentroById() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        id: this.data.centroId
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
       this.centroClientes = data.centro.clientes
        this.instalacionesCentro = data.centro.instalaciones
        this.centro = data.centro
        this.idCentro = data.centro.IdCentro
        this.licencias = data.centro.IDLicencias
       
         this.getClientesByContrastita()
         
      })
  }

  updateCentroById() {
    let centrosCliente:any =[]
    this.centroClientes.forEach((centro:any) => {
      
      centrosCliente.push(centro.id)
    });
    centrosCliente.push(this.centro.id)
   
    let updateInstalaciones:any = []
    console.log(this.instalacionesCentro)
    console.log(this.instalacionSeleccionado)
    this.instalacionesCentro.forEach((instalacion:any) => {
      updateInstalaciones.push(instalacion.id)
    });
   
    console.log(updateInstalaciones)
    this.apollo.mutate({
      mutation: this.centroService.updateCentro(),
      variables: {
        "input": {
          "where": {
            "id": this.data.centroId
          },
          "data": {
            "clientes": centrosCliente,
            "instalaciones": updateInstalaciones
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
        this.updateClienteById(this.centrosYaCliente)
        this.updateLicencia(this.lastLicencia.id)
        /* setTimeout(() => {
          location.reload()
        }, 1000);  */
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getClienteById(){
    
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.clienteSeleccionado
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
        this.instalaciones = data.cliente.instalaciones
        this.centrosYaCliente = data.cliente.centros
        this.idClienteCustom = data.cliente.customID
        this.contadorLicencia = data.cliente.licencias.filter((licencia:any)=>!licencia.IDLicencia).length
      })
  }

  updateClienteById(centrosCliente:any) {
    
    let updateCentros:any = []
    centrosCliente.forEach((centro:any) => {
      updateCentros.push(centro.id)
    });
    updateCentros.push(this.data.centroId)
    console.log(updateCentros)
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.clienteSeleccionado
          },
          "data": {
            "centros": updateCentros
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
        this.licenciasPagadas = this.licenciasPagadas-1
        this.updateContratistaById()
      }, (error) => {
        console.log('aaaaa', error)
      })


  }

  updateContratistaById() {
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.userLog.contratista.id
          },
          "data": {
            
            "licenciasPagadas": this.licenciasPagadas
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  updateLicencia(id:any) {
    console.log(id);
    
    let codLicencia = 'XT/CL'+this.idClienteCustom+'/'+this.idCentro
    this.apollo.mutate({
        mutation: this.licenciaService.updateLicencia(),
        variables: {
          "input": {
            "where": {
              "id": id
            },
            "data": {
              "fechaConfirmacion": this.fechaConfirmacion,
              "fechaCaducidad": this.fechaCaducidad,
              "fechaRenovacion": this.fechaRenovacion,
              "centro": this.data.centroId,
              "cliente":this.clienteSeleccionado,
              "contratista": this.userLog.contratista.id,
              "licenciaActiva":true,
              "IDLicencia": codLicencia
             
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
          
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }


}
